import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='updateCollectedData(collectableData: NolPayUnlinkCollectableData)' mdxType="Item">
      <p>{`Update component with collected data by passing implementations of sealed interface representing collectable data for unlinking a Nol Pay card. This method can be called at any point, even if you have only partially collected data. To validate the partially collected data, you can refer to the `}<a parentName="p" {...{
          "href": ".#nolpayunlinkcardcomponent.validationDelegate"
        }}>{`validationDelegate`}</a></p>
  <Group summary='enum NolPayUnlinkCollectableData' mdxType="Group">
  <Item title='cardAndPhoneData' mdxType="Item">
          <p>{`  Data class representing Nol Pay card and phone data for unlinking.`}</p>
  <Group summary='Properties' open mdxType="Group">
   <Item title='nolPaymentCard' subtitle='PrimerNolPaymentCard' mdxType="Item">
              <p>{`The Nol Pay payment card to unlink is retrieved using `}<a parentName="p" {...{
                  "href": "./../nolPayLinkedCardsComponent"
                }}>{`NolPayLinkedCardsComponent`}</a>{`.`}</p>
   </Item>
            <Item title='mobileNumber' mdxType="Item">
              <p>{`The mobile number in `}<a parentName="p" {...{
                  "href": "https://www.twilio.com/docs/glossary/what-e164"
                }}>{`E.164`}</a>{` format for which linked cards are to be retrieved.`}</p>
            </Item>
   </Group>
  </Item>
        <Item title='NolPayOtpData' mdxType="Item">
Data class representing Nol Pay OTP (One-Time Password) data collected during the unlinking process.
  <Group summary='Properties' open mdxType="Group">
    <Item title='otpCode' mdxType="Item">
    The OTP code required for card linking.
    </Item>
  </Group>
        </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      